



















import Vue from "vue";

export default Vue.extend({
  props: {
    component: {
      type: String,
      default: "button",
    },
    className: {
      type: String,
      required: false,
      default: "",
    },
    loading: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
});
